/**
 * PV EA Offers — campaign prices
 * When the Froya campaign engine has a first-order price for a card's
 * variant (assets/pv-ea-campaign.js), re-render the per-jar price, the
 * "Save x%" ribbon and the "add to cart - $x" label from it, with the same
 * math as the section's Liquid:
 *   total     = campaign unit price x quantity
 *   per jar   = total / (paid + free jars), rounded to whole dollars
 *   save %    = (compare per jar x all jars - total) / that, rounded down
 * No campaign price (no phase running, or no discount on the variant): the
 * Liquid values come back. The renewal fine print is Loop's and unchanged.
 */

(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.ready === 'true') return;
    card.dataset.ready = 'true';

    var save = card.querySelector('[data-pv-ea-offer-save]');
    var amount = card.querySelector('[data-pv-ea-offer-amount]');
    var atc = card.querySelector('[data-pv-ea-offer-atc]');
    var original = {
      save: save && save.textContent,
      amount: amount && amount.textContent,
      atc: atc && atc.textContent
    };

    var qty = parseInt(card.dataset.qty, 10) || 1;
    var totalJars = parseInt(card.dataset.totalJars, 10) || 1;
    var comparePerJar = parseInt(card.dataset.comparePerJar, 10) || 0;

    function restore() {
      if (save) save.textContent = original.save;
      if (amount) amount.textContent = original.amount;
      if (atc) atc.textContent = original.atc;
    }

    function update() {
      PVEaCampaign.price(card.dataset.variant, card.dataset.handle, card.dataset.kind).then(function (unit) {
        if (unit == null) {
          restore();
          return;
        }
        var total = unit * qty;
        var perJar = Math.floor((Math.floor(total / totalJars) + 50) / 100) * 100;
        var reference = comparePerJar * totalJars;
        var pct = reference > total ? Math.floor(((reference - total) * 100) / reference) : 0;

        if (amount) amount.textContent = PVEaCampaign.money(perJar, true);
        if (save && pct > 0) save.textContent = (card.dataset.saveLabel || '').replace('{pct}', pct);
        if (atc && (card.dataset.atcLabel || '').indexOf('{price}') !== -1) {
          atc.textContent = card.dataset.atcLabel.replace('{price}', PVEaCampaign.money(total, true));
        }
      });
    }

    PVEaCampaign.watch(update);
  }

  function initAll(scope) {
    if (!window.PVEaCampaign) return;
    (scope || document).querySelectorAll('[data-pv-ea-offer]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
